import React, { useState } from 'react';
import {
  ACADEMY_BIT_PAYMENT_PHONE,
  ACADEMY_BIT_PAYMENT_PHONE_DISPLAY,
} from '../constants/coursePayment';

export default function CoursePurchaseSection({ id = 'course-purchase', course, user }) {
  const [receiptFile, setReceiptFile] = useState(null);
  const [copied, setCopied] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const price = course?.price || course?.details?.price || '';
  const displayName = String(user?.name || '').trim() || 'אורח/ת';

  const copyBitPhone = async () => {
    try {
      await navigator.clipboard.writeText(ACADEMY_BIT_PAYMENT_PHONE);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2200);
    } catch {
      window.prompt('העתיקו את המספר:', ACADEMY_BIT_PAYMENT_PHONE);
    }
  };

  const handleReceiptChange = (event) => {
    const file = event.target.files?.[0];
    setReceiptFile(file || null);
  };

  const handleSubmitReceipt = (event) => {
    event.preventDefault();
    if (!receiptFile) return;
    setSubmitted(true);
  };

  return (
    <section
      id={id}
      className="gl-course-landing__purchase"
      aria-labelledby="course-purchase-title"
    >
      <div className="gl-course-landing__purchase-head">
        <p className="gl-kicker">שלב אחרון</p>
        <h2 id="course-purchase-title">רכישה ותשלום</h2>
        <p className="gl-course-landing__purchase-lead">
          {displayName}, אחרי התשלום העלו קבלה — נאשר את הגישה והקורס יופיע באיזור האישי.
        </p>
      </div>

      <div className="gl-course-landing__checkout">
        <aside className="gl-course-landing__order" aria-label="סיכום הזמנה">
          <h3>סיכום</h3>
          <div className="gl-course-landing__order-line">
            <span className="gl-course-landing__order-name">{course.title}</span>
            <span className="gl-course-landing__order-price">{price}</span>
          </div>
          <div className="gl-course-landing__order-total">
            <span>סה״כ לתשלום</span>
            <strong>{price}</strong>
          </div>
          <ol className="gl-course-landing__steps-hint">
            <li>שלחו תשלום בביט</li>
            <li>העלו אישור / קבלה</li>
            <li>מקבלים גישה לאחר אימות</li>
          </ol>
        </aside>

        <div className="gl-course-landing__payment">
          <article className="gl-course-landing__bit">
            <div className="gl-course-landing__bit-head">
              <span className="gl-course-landing__step-num" aria-hidden="true">1</span>
              <div>
                <span className="gl-course-landing__bit-badge">Bit</span>
                <h3>תשלום בביט</h3>
              </div>
            </div>
            <p>
              פתחו את אפליקציית ביט, בחרו העברה או תשלום, והזינו את המספר והסכום{' '}
              <strong>{price}</strong>.
            </p>
            <div className="gl-course-landing__bit-phone">
              <a href={`tel:${ACADEMY_BIT_PAYMENT_PHONE}`}>{ACADEMY_BIT_PAYMENT_PHONE_DISPLAY}</a>
              <span className="gl-course-landing__bit-intl">{ACADEMY_BIT_PAYMENT_PHONE}</span>
              <button type="button" onClick={copyBitPhone}>
                {copied ? 'הועתק ✓' : 'העתק מספר'}
              </button>
            </div>
          </article>

          <form className="gl-course-landing__receipt" onSubmit={handleSubmitReceipt}>
            <div className="gl-course-landing__bit-head">
              <span className="gl-course-landing__step-num" aria-hidden="true">2</span>
              <div>
                <h3>העלאת קבלה</h3>
              </div>
            </div>
            <p className="gl-course-landing__receipt-hint">
              צרפו צילום מסך או PDF מהביט. נאשר את הרכישה בהקדם האפשרי.
            </p>
            <label className="gl-course-landing__upload">
              <input
                type="file"
                accept="image/*,.pdf,application/pdf"
                onChange={handleReceiptChange}
                required
              />
              <span className="gl-course-landing__upload-icon" aria-hidden="true">↑</span>
              <span>{receiptFile ? receiptFile.name : 'בחרו קובץ קבלה או אישור תשלום'}</span>
            </label>
            {submitted ? (
              <p className="gl-course-landing__receipt-success" role="status">
                תודה! קיבלנו את הקבלה. נאשר את הרכישה בהקדם האפשרי.
              </p>
            ) : (
              <button
                type="submit"
                className="gl-academy-hero-cta gl-academy-hero-cta--primary gl-course-landing__receipt-submit"
                disabled={!receiptFile}
              >
                שליחת קבלה
              </button>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
